import React from 'react';
import Image from 'next/image';
import Link from 'next/link';

const CircuitBackground: React.FC = () => {
  return (
    <div className="absolute inset-0 overflow-hidden cursor-pointer" style={{ background: "#153C7F" }}>
      <div className="relative w-[600px] h-[400px] mt-8">
        <Image
          src="/background-image.png"
          alt="Circuit Background"
          fill
          style={{ objectFit: 'contain', objectPosition: 'left top' }}
          priority
        />
      </div>
    </div>
  );
};

export default CircuitBackground;
